(function () {
  var selector = 'img[loading="lazy"]:not([data-casidor-lookahead-ready])';
  var observer = null;

  function promote(image) {
    if (!image || image.dataset.casidorLookaheadReady === 'true') return;
    image.dataset.casidorLookaheadReady = 'true';
    image.loading = 'eager';

    // A horizontally clipped carousel can keep later cards outside the
    // observer's intersection area. Once the carousel approaches, preload its
    // complete image set so an auto-advance never reveals an empty card.
    var carousel = image.closest && image.closest('.casidor-benefit-image-cards');
    if (carousel) {
      Array.prototype.slice.call(carousel.querySelectorAll(selector)).forEach(function (carouselImage) {
        carouselImage.dataset.casidorLookaheadReady = 'true';
        carouselImage.loading = 'eager';
        if (observer) observer.unobserve(carouselImage);
      });
    }
  }

  function watch(image) {
    if (!image || image.dataset.casidorLookaheadReady === 'true') return;

    if (!observer) {
      promote(image);
      return;
    }

    observer.observe(image);
  }

  if ('IntersectionObserver' in window) {
    var verticalLookahead = window.matchMedia('(max-width: 749px)').matches ? 2400 : 1600;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        promote(entry.target);
        observer.unobserve(entry.target);
      });
    // Start fetching well before vertical sections or horizontal carousel cards
    // can enter the viewport. This preserves native lazy loading without showing
    // an empty card while an auto-advancing carousel waits for its image.
    }, { rootMargin: verticalLookahead + 'px 3200px', threshold: 0.01 });
  }

  function scan(context) {
    var root = context && context.querySelectorAll ? context : document;
    Array.prototype.slice.call(root.querySelectorAll(selector)).forEach(watch);

    if (context && context.matches && context.matches(selector)) {
      watch(context);
    }
  }

  scan(document);

  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.slice.call(mutation.addedNodes).forEach(scan);
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
